/**
 * Catálogo de produtos (ikaro_db.products.code) por família de serviço.
 * Os códigos devem existir no banco.
 */
export const ENVIRONMENT_PRODUCTS_CATALOG = [
  {
    id: "DOCUMENT_CREATION",
    label: "Criação de Documentos",
    products: [
      { code: "DC_CONTESTACAO", label: "Contestação" },
      { code: "DC_CONTESTACAO_DOSSIE", label: "Dossiê de Contestação" },
      { code: "DC_DOSSIE", label: "Dossiê" },
      { code: "DC_PROCON", label: "Procon" },
    ],
  },
  {
    id: "PROCESS_DIGITAL_PDF",
    label: "Processamento de PDF",
    products: [{ code: "PE_CUSTOM", label: "Custom" }],
  },
];
